<div class="container-fluid px-0 px-xl-5 py-4 py-xl-5">
	<div class="container-xl px-xl-0 ml-0">
		<div
			class="d-flex flex-wrap justify-content-between align-items-center mb-4"
		>
			<h2 class="mb-4 mb-md-0">
				{{ 'signature-removal-request_admin-list-title' | translate }}
			</h2>

			<div
				class="d-flex align-items-center sort-container"
				*ngIf="searchParams"
			>
				<label class="mr-2">
					{{ 'signature-removal-request_filter_status' | translate }}
				</label>
				<nz-select
					[ngModel]="statusFilter"
					(ngModelChange)="handleStatusChange($event)"
					style="min-width: 160px"
				>
					<nz-option
						*ngFor="let option of statusOptions"
						[nzValue]="option"
						[nzLabel]="getStatusKey(option) | translate"
					>
					</nz-option>
				</nz-select>
			</div>
		</div>
	</div>

	<div *ngIf="searchParams" class="container-xl px-xl-0 ml-0">
		<div class="row">
			<div class="col-12 py-4 px-0">
				<ng-container *ngIf="loading">
					<div class="text-center">
						<app-atom-concept-loader></app-atom-concept-loader>
					</div>
				</ng-container>

				<ng-container *ngIf="!loading">
					<ng-container
						*ngIf="requests && requests.length > 0; else emptyTpl"
					>
						<div class="table-container">
							<table class="signature-removal-table">
								<thead>
									<tr>
										<th>
											{{
												'signature-removal-request_col_thematique'
													| translate
											}}
										</th>
										<th>
											{{
												'signature-removal-request_col_stagiaire'
													| translate
											}}
										</th>
										<th>
											{{
												'signature-removal-request_col_formateur'
													| translate
											}}
										</th>
										<th>
											{{
												'signature-removal-request_col_date'
													| translate
											}}
										</th>
										<th>
											{{
												'signature-removal-request_col_period'
													| translate
											}}
										</th>
										<th>
											{{
												'signature-removal-request_col_status'
													| translate
											}}
										</th>
										<th>
											{{
												'signature-removal-request_col_created-at'
													| translate
											}}
										</th>
										<th>
											{{
												'signature-removal-request_col_action'
													| translate
											}}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										*ngFor="
											let request of requests;
											trackBy: trackById
										"
									>
										<td>
											{{ getThematiqueLabel(request) }}
										</td>
										<td>
											{{ getStagiaireLabel(request) }}
										</td>
										<td>
											{{ getRequesterLabel(request) }}
										</td>
										<td>
											{{
												request.props.attestation_date
													| date
														: 'dd/MM/yyyy'
														: ''
														: 'fr-FR'
											}}
										</td>
										<td>
											{{
												getPeriodKey(
													request.props
														.attestation_period
												) | translate
											}}
										</td>
										<td>
											<span
												class="status-tag"
												[attr.data-color]="
													getStatusColor(
														request.props.status
													)
												"
											>
												{{
													getStatusKey(
														request.props.status
													) | translate
												}}
											</span>
										</td>
										<td>
											{{
												request.props.created_at
													| date
														: 'dd/MM/yyyy HH:mm'
														: ''
														: 'fr-FR'
											}}
										</td>
										<td>
											<a
												[routerLink]="[
													'/signature-removal-requests/admin',
													request.getId()
												]"
											>
												{{
													'signature-removal-request_action_open'
														| translate
												}}
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</ng-container>
				</ng-container>
			</div>
		</div>

		<div class="row" *ngIf="totalItems > limit">
			<div class="col-12 d-flex justify-content-end">
				<nz-pagination
					[nzPageIndex]="currentPageIndex"
					[nzPageSize]="limit"
					[nzTotal]="totalItems"
					(nzPageIndexChange)="handleNextPage($event)"
				></nz-pagination>
			</div>
		</div>
	</div>

	<ng-template #emptyTpl>
		<div class="col-12 py-4">
			<p>{{ 'signature-removal-request_no-results' | translate }}</p>
		</div>
	</ng-template>
</div>
